import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { VehicleDropdowns } from 'site-modules/shared/components/vehicle-dropdowns/vehicle-dropdowns';
import { SectionHeading } from 'site-modules/shared/components/editorial/section-heading/section-heading';

const DROPDOWNS_TEXT_DATA = {
  regular: {
    title: 'Read Consumer Reviews',
    subtitle: 'Read the opinions of thousands of car owners who have rated their own vehicles.',
  },
  tco: {
    title: 'True Cost to Own® Search',
    subtitle: 'Find out how much your car will cost over time.',
  },
};

export function onChangeReviews(make, model, submodel, year) {
  return `/${make.slug}/${model.slug}/${year.year}/consumer-reviews/`;
}

export function onChangeTCO(make, model, year, style) {
  return `/${make.slug}/${model.slug}/${year.year}/st-${style.id}/cost-to-own/`;
}

export function DropdownWidget({ widgetType = null }) {
  return (
    <Fragment>
      {widgetType === 'tco' ? (
        <div>
          <SectionHeading>{DROPDOWNS_TEXT_DATA.tco.title}</SectionHeading>
          <p className="h6 fw-normal px-1 mt-1">{DROPDOWNS_TEXT_DATA.tco.subtitle}</p>
          <VehicleDropdowns
            globalClasses="flex-column flex-nowrap mx-auto px-1 mt-1 mt-md-2_5 mt-lg-1"
            generateLink={onChangeTCO}
            hasSubmodel
            hasYear
            hasStyle
            showArrowButton={false}
            makeDropdownClassNames="pe-0"
            submodelDropdownClassNames="pe-0 ps-0"
            yearDropdownClassNames="pe-0"
            styleDropdownClassNames="pe-0 ps-0"
            buttonGroupClassNames="ms-auto mt-1"
          />
        </div>
      ) : (
        <div>
          <SectionHeading>{DROPDOWNS_TEXT_DATA.regular.title}</SectionHeading>
          <p className="h6 fw-normal px-1 mt-1">{DROPDOWNS_TEXT_DATA.regular.subtitle}</p>
          <VehicleDropdowns
            globalClasses="flex-column mx-auto px-1 mt-1 mt-md-2_5 mt-lg-1"
            generateLink={onChangeReviews}
            hasSubmodel
            hasYear
            showArrowButton={false}
            makeDropdownClassNames="pe-0 "
            yearDropdownClassNames="pe-0"
            submodelDropdownClassNames="pe-0 ps-0"
            buttonGroupClassNames="ms-auto mt-1"
          />
        </div>
      )}
    </Fragment>
  );
}

DropdownWidget.propTypes = {
  widgetType: PropTypes.string,
};
